<template>
<file-layout :show-header="true" background="#ebedef" :allow-share="false">
    <div :class="layoutClass">
      <div class="viewbox">
        <div class="left top">
          <img src="@/assets/h5/password.png">
        </div>
        <div class="right bottom">
          <div class="item caption">
            <span>{{$t("该文件需要密码#!!!#src/pages/H5/Cloud/components/PasswordView.vue_1")}}</span>
          </div>
          <div class="item input">
            <input v-model="code" @keyup.enter="submit" :placeholder="$t('输入密码#!!!#src/pages/H5/Cloud/components/PasswordView.vue_1')" maxlength="16" type="text">
          </div>
          <div class="item action">
            <button @click="submit">{{$t("确认#!!!#src/pages/H5/Cloud/components/PasswordView.vue_1")}}</button>
          </div>
          <div v-if="checkCode === 165" class="item tips">
            <span>{{$t("请输入正确的密码#!!!#src/pages/H5/Cloud/components/PasswordView.vue_1")}}</span>
          </div>
        </div>
      </div>
    </div>
  </file-layout>
</template>

<script>
import { mapState } from "vuex";
import FileLayout from "@/components/h5/Layout";
import { checkFile } from "@/api/h5/file";
export default {
  props: {
    message: {
      type: String,
    },
    fileId: {
      type: String,
    },
  },
  watch: {
    message(val) {
      this.alertText = val;
    },
  },
  components: {
    FileLayout,
  },
  data() {
    return {
      code: "",
      alertText: this.message,
      checkCode: 200,
    };
  },
  methods: {
    async submit() {
        this.alertText = "";
        this.checkCode = 200;
        const fileData = await checkFile(this.fileId, this.code || "");
        this.checkCode = fileData.code;
        if(fileData.code !== 165){
            this.$emit("password-commit", this.code);
        }
        
    },
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
    }),
    layoutClass() {
      return this.isPcMode ? "pc-password-view" : "h5-password-view";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

.pc-password-view {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ebedef;

  .viewbox {
    padding: 0 40px;
    background-color: #fff;
    height: 240px;
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 600px) {
      .left {
        padding-right: 20px;

        img {
          display: none;
        }
      }
    }

    @media (min-width: 600px) {
      .left {
        padding-right: 20px;

        img {
          width: 160px;
        }
      }
    }

    .right {
      .item {
        padding: 6px 0;
        line-height: 20px;
        min-height: 20px;
      }

      .caption {
        padding-top: 20px;

        span {
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }
      }

      .input {
        input {
          outline: none;
          width: 182px;
          height: 30px;
          padding: 0 8px;
          font-size: 14px;
          border-radius: 4px;
          background: #ffffff;
          border: 1px solid rgba(0, 0, 0, 0.15);
          box-shadow: inset 0 2px 1px 0 rgba(0, 0, 0, 0.05);
        }
      }

      .action {
        button {
          width: 200px;
          height: 30px;
          @include pc-primary-button;
        }
      }

      .tips {
        span {
          font-weight: 400;
          font-size: 13px;
          color: #b33e2f;
          line-height: 20px;
        }
      }
    }
  }
}

.h5-password-view {
  height: 100%;

  .viewbox {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;

    .top {
      margin-top: 40px;

      img {
        width: 120px;
      }
    }

    .bottom {
      display: flex;
      flex-direction: column;
      align-items: center;

      .caption {
        margin-top: 20px;

        span {
          font-size: 20px;
          color: #000000;
        }
      }

      .input {
        margin-top: 30px;

        input {
          width: 343px;
          height: 56px;
          background: #f7f7f8;
          border-radius: 28px;
          outline: none;
          border: none;
          font-size: 17px;
          text-align: center;

          &:focus {
            background: #fff;
          }
        }
      }

      .action {
        margin-top: 30px;

        button {
          @include h5-primary-button;
          width: 343px;
          height: 56px;
          font-size: 17px;
          border-radius: 28px;
        }
      }

      .tips {
        margin-top: 20px;

        span {
          font-size: 12px;
          color: #ff5944;
        }
      }
    }
  }
}
</style>
